import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

Vue.config.productionTip = false


// bootstrap Vue
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

// FontAwesome Icons
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)

// VueHead
import VueHead from 'vue-head'
Vue.use(VueHead)

// vue-clipboard2
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// vue-autosize
var VueAutosize = require('vue-autosize')
Vue.use(VueAutosize)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
